import { InjectionToken } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const ENVIRONMENT = new InjectionToken("IDP_ENVIRONMENT");

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const ENVIRONMENT_SCOPE = new InjectionToken("IDP_ENVIRONMENT_SCOPE");

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const ENVIRONMENT_CACHE = new InjectionToken("IDP_ENVIRONMENT_CACHE");

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const ENVIRONMENT_FACADE = new InjectionToken("IDP_ENVIRONMENT_FACADE");

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const ENVIRONMENT_INTERPOLATION_DATA = new InjectionToken("IDP_ENVIRONMENT_INTERPOLATION_DATA");

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const ENVIRONMENT_APPEND = new InjectionToken("IDP_ENVIRONMENT_APPEND");

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const APPLICATION_CONFIGURATION_FILENAME = new InjectionToken("IDP_APPLICATION_CONFIGURATION_FILENAME");

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const APPLICATION_CONFIGURATION_PATH = new InjectionToken("IDP_APPLICATION_CONFIGURATION_PATH");

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const APPLICATION_CONFIGURATION_URL = new InjectionToken("IDP_APPLICATION_CONFIGURATION_URL");

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { ENVIRONMENT, ENVIRONMENT_SCOPE, ENVIRONMENT_CACHE, ENVIRONMENT_FACADE, ENVIRONMENT_INTERPOLATION_DATA, ENVIRONMENT_APPEND, APPLICATION_CONFIGURATION_FILENAME, APPLICATION_CONFIGURATION_PATH, APPLICATION_CONFIGURATION_URL };

